<template>
    <div class="bg-white relative shadow-card flex flex-col items-center gap-2 p-8">
        <template v-for="membershipType in uniqueMembershipTypes">
            <img
                v-if="membershipType.badge !== null"

                :class="width"

                :src="membershipType.badge"
            />
        </template>

        <main-card 
            :member="memberType?.member ?? {}" 
            :membership-id="membership.uuid"
            :has-profile-button="false"
            :width="width"
        />

        <details-card 
            :member="memberType?.member ?? {}"
            :width="width"
        />
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import store from '@app/fac-search/state/store'
    import { unique } from '@app/helpers/array' 
    import MainCard from './MainCard.vue'
    import DetailsCard from './DetailsCard.vue'

    const props = defineProps({
        membership : Object,
        width      : {
            type: String,
            default: 'w-full'
        }
    })

    const memberType = computed(() => store.data.fac_type_memberships.getMemberType(props.membership))

    const uniqueMembershipTypes = computed(() => unique(Object.values(props.membership?.membership_types ?? []), 'id'))
</script>